import React, {useCallback, useState, useEffect} from 'react';
import {
    NUM_TRACKS,
    ADD_TRACKS,
    LOAD_TIME
} from './constants.js';

const MONTHS_WIDTH = 110;
const MARGIN = 30;
const WIDTH = 360;
const HEIGHT = 230;

export const useScroll = ({
    setIsLoading,
    isLoading,
    userWorks,
    setCurrentMonth,
    months,
    state,
    setState,
    works,
    personSelected
}) => {
    let {skipTracks, scrollTop, numTracks} = state;
    const onScroll = useCallback(() => {
        if (numTracks >= userWorks.length) {
            return;
        }
        let el = document.getElementById('works');
        if (isLoading) {
            return;
        }
        let bottom = el.scrollTop + el.offsetHeight;
        let height = el.scrollHeight;
        
        if (el.scrollTop <= scrollTop - 1300 && scrollTop > 50) {
            // this tells us the user wants to scroll to the very
            // beginning again (they've scrolled past the tracks were showing
            setTimeout(() => {
                setState({numTracks: NUM_TRACKS, scrollTop: 0});
                el.scrollTo(0, 0);
                setCurrentMonth(new Date().getMonth());
            }, LOAD_TIME);
            return;
        }

        if (bottom >= height) { 
            setIsLoading(true);
            let t = numTracks + ADD_TRACKS;
            if (!userWorks[t]) {
                setIsLoading(false);
                return;
            }
            let block =  userWorks[t].blockNumber;
            for (let month in months) {
                month = parseInt(month);
                if (block < months[month]) {
                    setCurrentMonth(month - 1);
                    break;
                }
            }
            
            setTimeout(() => {
                console.log('setting scrollTop=', el.scrollTop);
                setState({skipTracks, numTracks: numTracks + ADD_TRACKS, scrollTop: el.scrollTop});
                setIsLoading(false);
            }, LOAD_TIME);
        }

    }, [
        numTracks,
        setIsLoading,
        skipTracks,
        isLoading,
        setState,
        userWorks,
        setCurrentMonth,
        months,
        scrollTop]);

    function unbindScrolling() {
        let el = document.getElementById("works");
        el.removeEventListener('scroll', onScroll);
    }

    useEffect(() => {
        let el = document.getElementById('works');
        el.scrollTo(0, 0);
    }, [skipTracks]);

    useEffect(() => {
        let el = document.getElementById('works');
        setState({numTracks: NUM_TRACKS, scrollTop: 0});
        el.scrollTo(0, 0);
        setCurrentMonth(new Date().getMonth());
    }, [personSelected, setCurrentMonth]);

    useEffect(() => {
        let el = document.getElementById("works");
        el.addEventListener('scroll', onScroll);
        return unbindScrolling;
    }, [onScroll, userWorks, state, skipTracks]);

    let toSkip = skipTracks;
    if (skipTracks === undefined) {
        let perRow = Math.max(1,Math.floor((window.innerWidth - MONTHS_WIDTH) / (WIDTH + 2*MARGIN)));
        let rowsToSkip = Math.floor(scrollTop / (HEIGHT + 2*MARGIN));
        let toSkip = rowsToSkip * perRow;
        if (numTracks === NUM_TRACKS) {
            toSkip = 0;
        }
        
        toSkip = Math.max(0, toSkip - 50);
    }
    let _works = works.slice(toSkip, numTracks);
    toSkip = skipTracks !== undefined ? 0 : toSkip;
    
    return {onScroll, scrollWorks: _works, toSkip};
};
